import { handleActions } from 'redux-actions';
import { UPDATE_TOKEN } from '../actionTypes';
import { token } from '../initialState';

export default handleActions(
  {
    [UPDATE_TOKEN]: (state, action) => {
      return action.payload;
    }
  },
  token
);
